var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{attrs:{"absolute":"","inset":"","dark":"","app":""}},[_c('span',[_vm._v("© Qode 2024")])])}
var staticRenderFns = []

export { render, staticRenderFns }